const MANUAL_PAYMENT_SUMMARY = {
  groups: {
    Markup: {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar pagamentos de markup.',
    },
    Frete: {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar pagamentos de frete.',
    },
    Incentivos: {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar pagamentos ou cobranças de incentivos.',
    },
    'Cupons e Descontos': {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar pagamentos de cupons e descontos.',
    },
    'Taxas e Comissões': {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar cobranças de taxas e comissões.',
    },
    Outros: {
      tooltipText:
        'Ajuste manual de valores para corrigir ou complementar pagamentos de outros tipos de restituição.',
    },
  } as Record<string, { tooltipText: string }>,
  downloadButtonTextSuffix: 'pagamentos manuais',
  errorMessage:
    'Houve um erro ao carregar o resumo de pagamentos manuais. Tente novamente mais tarde.',
  errorMessageManualPaymentTotalMismatch:
    'Restitution details manual payment total mismatch',
}

export default MANUAL_PAYMENT_SUMMARY
